"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swingIn = void 0;
const gsap_1 = require("gsap");
const swingIn = (target) => {
    return gsap_1.gsap.timeline().fromTo(target, {
        duration: 0,
        opacity: 0,
        scaleY: 0,
        transformOrigin: 'center center',
    }, {
        duration: 1,
        opacity: 1,
        scaleY: 1,
        transformOrigin: 'center center',
    });
};
exports.swingIn = swingIn;
//# sourceMappingURL=swing-in.js.map